var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfount"},[_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("../assets/404.png"),"alt":""}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('a',{attrs:{"href":"/home"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("回首页")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1434119e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notfount.vue
// module id = null
// module chunks = 